/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: fa3uzsyXr0

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicIcon as PlasmicIcon__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  StrictProps,
  useDollarState,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_data_binding.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicDataPickerColumnItem.module.css"; // plasmic-import: fa3uzsyXr0/css

import OpenIcon from "../plasmic_kit/PlasmicIcon__Open"; // plasmic-import: 7D0GDLdF72udM/icon
import PlaySvgIcon from "../plasmic_kit/PlasmicIcon__PlaySvg"; // plasmic-import: j39GoLwZnf7-v/icon
import ResetIcon from "../plasmic_kit/PlasmicIcon__Reset"; // plasmic-import: Dj3u-HuPv94sN/icon
import ChevronRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronRightSvg"; // plasmic-import: HBGx-zeiX/icon
import TextSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__TextSvg"; // plasmic-import: e3P4cMPJR/icon

createPlasmicElementProxy;

export type PlasmicDataPickerColumnItem__VariantMembers = {
  step: "notPlayed" | "played";
  variableType:
    | "string"
    | "number"
    | "boolean"
    | "object"
    | "array"
    | "undefined"
    | "func";
  isSelected: "isSelected";
  hasLink: "hasLink";
};
export type PlasmicDataPickerColumnItem__VariantsArgs = {
  step?: SingleChoiceArg<"notPlayed" | "played">;
  variableType?: SingleChoiceArg<
    "string" | "number" | "boolean" | "object" | "array" | "undefined" | "func"
  >;
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  hasLink?: SingleBooleanChoiceArg<"hasLink">;
};
type VariantPropType = keyof PlasmicDataPickerColumnItem__VariantsArgs;
export const PlasmicDataPickerColumnItem__VariantProps =
  new Array<VariantPropType>("step", "variableType", "isSelected", "hasLink");

export type PlasmicDataPickerColumnItem__ArgsType = {};
type ArgPropType = keyof PlasmicDataPickerColumnItem__ArgsType;
export const PlasmicDataPickerColumnItem__ArgProps = new Array<ArgPropType>();

export type PlasmicDataPickerColumnItem__OverridesType = {
  root?: Flex__<"div">;
  icon?: Flex__<"svg">;
  itemName?: Flex__<"div">;
  previewValue?: Flex__<"div">;
  link?: Flex__<typeof IconButton>;
  play?: Flex__<typeof IconButton>;
  iconButton?: Flex__<typeof IconButton>;
};

export interface DefaultDataPickerColumnItemProps {
  step?: SingleChoiceArg<"notPlayed" | "played">;
  variableType?: SingleChoiceArg<
    "string" | "number" | "boolean" | "object" | "array" | "undefined" | "func"
  >;
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  hasLink?: SingleBooleanChoiceArg<"hasLink">;
  className?: string;
}

const $$ = {};

function PlasmicDataPickerColumnItem__RenderFunc(props: {
  variants: PlasmicDataPickerColumnItem__VariantsArgs;
  args: PlasmicDataPickerColumnItem__ArgsType;
  overrides: PlasmicDataPickerColumnItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "variableType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.variableType,
      },
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isSelected,
      },
      {
        path: "step",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.step,
      },
      {
        path: "hasLink",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.hasLink,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_w2GXN278dkQ2gQTVQnPehW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.roothasLink]: hasVariant($state, "hasLink", "hasLink"),
          [sty.rootisSelected]: hasVariant($state, "isSelected", "isSelected"),
          [sty.rootisSelected_variableType_array]:
            hasVariant($state, "isSelected", "isSelected") &&
            hasVariant($state, "variableType", "array"),
          [sty.rootisSelected_variableType_func]:
            hasVariant($state, "variableType", "func") &&
            hasVariant($state, "isSelected", "isSelected"),
          [sty.rootisSelected_variableType_object]:
            hasVariant($state, "isSelected", "isSelected") &&
            hasVariant($state, "variableType", "object"),
          [sty.rootisSelected_variableType_undefined]:
            hasVariant($state, "variableType", "undefined") &&
            hasVariant($state, "isSelected", "isSelected"),
          [sty.rootstep_notPlayed]: hasVariant($state, "step", "notPlayed"),
          [sty.rootstep_notPlayed_variableType_number]:
            hasVariant($state, "variableType", "number") &&
            hasVariant($state, "step", "notPlayed"),
          [sty.rootstep_played]: hasVariant($state, "step", "played"),
          [sty.rootvariableType_array]: hasVariant(
            $state,
            "variableType",
            "array"
          ),
          [sty.rootvariableType_boolean]: hasVariant(
            $state,
            "variableType",
            "boolean"
          ),
          [sty.rootvariableType_func]: hasVariant(
            $state,
            "variableType",
            "func"
          ),
          [sty.rootvariableType_number]: hasVariant(
            $state,
            "variableType",
            "number"
          ),
          [sty.rootvariableType_object]: hasVariant(
            $state,
            "variableType",
            "object"
          ),
          [sty.rootvariableType_string]: hasVariant(
            $state,
            "variableType",
            "string"
          ),
          [sty.rootvariableType_undefined]: hasVariant(
            $state,
            "variableType",
            "undefined"
          ),
        }
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <div
        className={classNames("all", sty.freeBox__qdAAo, {
          [sty.freeBoxhasLink__qdAAoKQb90]: hasVariant(
            $state,
            "hasLink",
            "hasLink"
          ),
          [sty.freeBoxisSelected__qdAAoUtDu]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
          [sty.freeBoxvariableType_array__qdAAorW4TV]: hasVariant(
            $state,
            "variableType",
            "array"
          ),
          [sty.freeBoxvariableType_boolean__qdAAo0LWs]: hasVariant(
            $state,
            "variableType",
            "boolean"
          ),
          [sty.freeBoxvariableType_object__qdAAowXdSt]: hasVariant(
            $state,
            "variableType",
            "object"
          ),
          [sty.freeBoxvariableType_string__qdAAowYgzm]: hasVariant(
            $state,
            "variableType",
            "string"
          ),
        })}
      >
        <TextSvgIcon
          data-plasmic-name={"icon"}
          data-plasmic-override={overrides.icon}
          className={classNames("all", sty.icon)}
          role={"img"}
        />

        <div
          className={classNames("all", sty.freeBox___2XUqB, {
            [sty.freeBoxvariableType_array___2XUqBrW4TV]: hasVariant(
              $state,
              "variableType",
              "array"
            ),
            [sty.freeBoxvariableType_object___2XUqBwXdSt]: hasVariant(
              $state,
              "variableType",
              "object"
            ),
          })}
        >
          <div
            className={classNames("all", sty.freeBox__pWz6X, {
              [sty.freeBoxhasLink__pWz6XkQb90]: hasVariant(
                $state,
                "hasLink",
                "hasLink"
              ),
              [sty.freeBoxisSelected__pWz6XUtDu]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
              [sty.freeBoxstep_notPlayed__pWz6Xc2TI9]: hasVariant(
                $state,
                "step",
                "notPlayed"
              ),
              [sty.freeBoxstep_played__pWz6XvLpb6]: hasVariant(
                $state,
                "step",
                "played"
              ),
              [sty.freeBoxvariableType_array__pWz6XrW4TV]: hasVariant(
                $state,
                "variableType",
                "array"
              ),
            })}
          >
            <div
              data-plasmic-name={"itemName"}
              data-plasmic-override={overrides.itemName}
              className={classNames("all", "__wab_text", sty.itemName, {
                [sty.itemNameisSelected]: hasVariant(
                  $state,
                  "isSelected",
                  "isSelected"
                ),
                [sty.itemNameisSelected_variableType_func]:
                  hasVariant($state, "variableType", "func") &&
                  hasVariant($state, "isSelected", "isSelected"),
                [sty.itemNameisSelected_variableType_undefined]:
                  hasVariant($state, "variableType", "undefined") &&
                  hasVariant($state, "isSelected", "isSelected"),
                [sty.itemNamevariableType_boolean]: hasVariant(
                  $state,
                  "variableType",
                  "boolean"
                ),
                [sty.itemNamevariableType_number]: hasVariant(
                  $state,
                  "variableType",
                  "number"
                ),
                [sty.itemNamevariableType_object]: hasVariant(
                  $state,
                  "variableType",
                  "object"
                ),
                [sty.itemNamevariableType_string]: hasVariant(
                  $state,
                  "variableType",
                  "string"
                ),
              })}
            >
              {"Name"}
            </div>
          </div>
          <div
            data-plasmic-name={"previewValue"}
            data-plasmic-override={overrides.previewValue}
            className={classNames("all", "__wab_text", sty.previewValue, {
              [sty.previewValueisSelected_variableType_array]:
                hasVariant($state, "isSelected", "isSelected") &&
                hasVariant($state, "variableType", "array"),
              [sty.previewValueisSelected_variableType_func]:
                hasVariant($state, "variableType", "func") &&
                hasVariant($state, "isSelected", "isSelected"),
              [sty.previewValueisSelected_variableType_object]:
                hasVariant($state, "isSelected", "isSelected") &&
                hasVariant($state, "variableType", "object"),
              [sty.previewValueisSelected_variableType_undefined]:
                hasVariant($state, "variableType", "undefined") &&
                hasVariant($state, "isSelected", "isSelected"),
              [sty.previewValuestep_notPlayed]: hasVariant(
                $state,
                "step",
                "notPlayed"
              ),
              [sty.previewValuevariableType_array]: hasVariant(
                $state,
                "variableType",
                "array"
              ),
              [sty.previewValuevariableType_boolean]: hasVariant(
                $state,
                "variableType",
                "boolean"
              ),
              [sty.previewValuevariableType_func]: hasVariant(
                $state,
                "variableType",
                "func"
              ),
              [sty.previewValuevariableType_number]: hasVariant(
                $state,
                "variableType",
                "number"
              ),
              [sty.previewValuevariableType_object]: hasVariant(
                $state,
                "variableType",
                "object"
              ),
              [sty.previewValuevariableType_string]: hasVariant(
                $state,
                "variableType",
                "string"
              ),
              [sty.previewValuevariableType_undefined]: hasVariant(
                $state,
                "variableType",
                "undefined"
              ),
            })}
          >
            {hasVariant($state, "variableType", "func")
              ? "function"
              : hasVariant($state, "variableType", "undefined")
              ? "undefined"
              : hasVariant($state, "variableType", "array")
              ? "3 items"
              : hasVariant($state, "variableType", "object")
              ? "object"
              : hasVariant($state, "variableType", "boolean")
              ? "true"
              : hasVariant($state, "variableType", "number")
              ? "123"
              : hasVariant($state, "step", "notPlayed")
              ? "Not executed"
              : '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."'}
          </div>
        </div>
      </div>
      <div
        className={classNames("all", sty.freeBox__luqpj, {
          [sty.freeBoxhasLink__luqpjKQb90]: hasVariant(
            $state,
            "hasLink",
            "hasLink"
          ),
          [sty.freeBoxisSelected__luqpjUtDu]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
          [sty.freeBoxstep_notPlayed__luqpjC2TI9]: hasVariant(
            $state,
            "step",
            "notPlayed"
          ),
          [sty.freeBoxstep_notPlayed_variableType_number__luqpjC2TI9JKHiW]:
            hasVariant($state, "variableType", "number") &&
            hasVariant($state, "step", "notPlayed"),
          [sty.freeBoxvariableType_object__luqpjwXdSt]: hasVariant(
            $state,
            "variableType",
            "object"
          ),
        })}
      >
        <IconButton
          data-plasmic-name={"link"}
          data-plasmic-override={overrides.link}
          className={classNames("__wab_instance", sty.link, {
            [sty.linkhasLink]: hasVariant($state, "hasLink", "hasLink"),
            [sty.linkvariableType_object]: hasVariant(
              $state,
              "variableType",
              "object"
            ),
          })}
          size={"small"}
        >
          <OpenIcon
            className={classNames("all", sty.svg__i9Yw, {
              [sty.svghasLink__i9YwKQb90]: hasVariant(
                $state,
                "hasLink",
                "hasLink"
              ),
              [sty.svgisSelected__i9YwUtDu]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
              [sty.svgstep_notPlayed__i9YwC2TI9]: hasVariant(
                $state,
                "step",
                "notPlayed"
              ),
              [sty.svgvariableType_object__i9YwwXdSt]: hasVariant(
                $state,
                "variableType",
                "object"
              ),
            })}
            role={"img"}
          />
        </IconButton>
        <IconButton
          data-plasmic-name={"play"}
          data-plasmic-override={overrides.play}
          children2={
            <svg
              className={classNames("all", sty.svg__n3XOl, {
                [sty.svgstep_notPlayed__n3XOlc2TI9]: hasVariant(
                  $state,
                  "step",
                  "notPlayed"
                ),
              })}
              role={"img"}
            />
          }
          className={classNames("__wab_instance", sty.play, {
            [sty.playstep_notPlayed]: hasVariant($state, "step", "notPlayed"),
            [sty.playstep_notPlayed_variableType_number]:
              hasVariant($state, "variableType", "number") &&
              hasVariant($state, "step", "notPlayed"),
            [sty.playstep_played]: hasVariant($state, "step", "played"),
          })}
          size={"small"}
        >
          <PlasmicIcon__
            PlasmicIconType={
              hasVariant($state, "step", "played") ? ResetIcon : PlaySvgIcon
            }
            className={classNames("all", sty.svg__gIs5H, {
              [sty.svgisSelected__gIs5HUtDu]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
              [sty.svgstep_notPlayed__gIs5Hc2TI9]: hasVariant(
                $state,
                "step",
                "notPlayed"
              ),
              [sty.svgstep_notPlayed_variableType_number__gIs5Hc2TI9JKHiW]:
                hasVariant($state, "variableType", "number") &&
                hasVariant($state, "step", "notPlayed"),
              [sty.svgstep_played__gIs5HvLpb6]: hasVariant(
                $state,
                "step",
                "played"
              ),
            })}
            role={"img"}
          />
        </IconButton>
        <IconButton
          data-plasmic-name={"iconButton"}
          data-plasmic-override={overrides.iconButton}
          className={classNames("__wab_instance", sty.iconButton, {
            [sty.iconButtonvariableType_array]: hasVariant(
              $state,
              "variableType",
              "array"
            ),
            [sty.iconButtonvariableType_object]: hasVariant(
              $state,
              "variableType",
              "object"
            ),
          })}
          size={"small"}
        >
          <ChevronRightSvgIcon
            className={classNames("all", sty.svg__rIbNe, {
              [sty.svgisSelected__rIbNeUtDu]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
              [sty.svgstep_notPlayed__rIbNec2TI9]: hasVariant(
                $state,
                "step",
                "notPlayed"
              ),
              [sty.svgvariableType_array__rIbNErW4TV]: hasVariant(
                $state,
                "variableType",
                "array"
              ),
              [sty.svgvariableType_object__rIbNEwXdSt]: hasVariant(
                $state,
                "variableType",
                "object"
              ),
            })}
            role={"img"}
          />
        </IconButton>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "icon",
    "itemName",
    "previewValue",
    "link",
    "play",
    "iconButton",
  ],
  icon: ["icon"],
  itemName: ["itemName"],
  previewValue: ["previewValue"],
  link: ["link"],
  play: ["play"],
  iconButton: ["iconButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  icon: "svg";
  itemName: "div";
  previewValue: "div";
  link: typeof IconButton;
  play: typeof IconButton;
  iconButton: typeof IconButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDataPickerColumnItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDataPickerColumnItem__VariantsArgs;
    args?: PlasmicDataPickerColumnItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicDataPickerColumnItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDataPickerColumnItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDataPickerColumnItem__ArgProps,
          internalVariantPropNames: PlasmicDataPickerColumnItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDataPickerColumnItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDataPickerColumnItem";
  } else {
    func.displayName = `PlasmicDataPickerColumnItem.${nodeName}`;
  }
  return func;
}

export const PlasmicDataPickerColumnItem = Object.assign(
  // Top-level PlasmicDataPickerColumnItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    icon: makeNodeComponent("icon"),
    itemName: makeNodeComponent("itemName"),
    previewValue: makeNodeComponent("previewValue"),
    link: makeNodeComponent("link"),
    play: makeNodeComponent("play"),
    iconButton: makeNodeComponent("iconButton"),

    // Metadata about props expected for PlasmicDataPickerColumnItem
    internalVariantProps: PlasmicDataPickerColumnItem__VariantProps,
    internalArgProps: PlasmicDataPickerColumnItem__ArgProps,
  }
);

export default PlasmicDataPickerColumnItem;
/* prettier-ignore-end */
